import React from 'react';
import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';
import {
  Container,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

type Props = Extract<
  LandingPageConfig['data']['slices'][number],
  { type: 'frequently-asked-questions' }
> & {
  backgroundColor: string;
};

const FrequentlyAskedQuestions: React.FC<Props> = (props) => {
  const { title, questions, backgroundColor } = props;

  return (
    <Box sx={{ backgroundColor, py: 10 }}>
      <Container maxWidth="md">
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '32px', md: '48px' },
            fontWeight: 600,
            textAlign: { xs: 'left', md: 'center' },
            mb: 6,
            px: { xs: 2, md: 0 },
          }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            border: '1px solid #E5E5E5',
            borderRadius: '16px',
            overflow: 'hidden',
          }}
        >
          {questions.map((faq, index) => (
            <Accordion
              key={index}
              disableGutters
              elevation={0}
              sx={{
                '&:not(:last-child)': {
                  borderBottom: '1px solid #E5E5E5',
                },
                '&:before': { display: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: '#666666' }} />}
                sx={{
                  px: 3,
                  py: 0.5,
                  '&:hover': { backgroundColor: '#FAFAFA' },
                }}
              >
                <Box
                  sx={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '8px',
                    backgroundColor: '#F0F0F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mr: 2,
                    flexShrink: 0,
                  }}
                >
                  <ChatBubbleIcon sx={{ fontSize: '20px', color: '#AAAAAA' }} />
                </Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 600 }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 3, pb: 3, pl: '82px' }}>
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#666666',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

export default FrequentlyAskedQuestions;
